import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MortgageService } from '../../../mortgage/services/mortgage/mortgage.service';
import { ModalGenericComponent } from '../../../shared/components/modal-generic/modal-generic.component';
import { ConfirmationService } from '../../../vass-core/components/modal/confirmation.service';
import { SimulateResultData } from '../../models/ui/simulate-result-data.model';

// Precio vivienda: this.simulateResult.formValues.propertyPrice
// Aportado: this.simulateResult.formValues.savingsMade
// Gastos compra vivienda: this.simulateResult.mortgageResult.expenses.trading.total;
// Gastos hipoteca this.simulateResult.mortgageResult.expenses.mortgage.total;
const listHeight = {
  propertyPrice: 50,
  savingsMade: 30,
  tradingTotal: 15,
  mortgageTotal: 5,
  mortgageAmount: 50,
};

@Component({
  selector: 'app-simulation-result',
  templateUrl: './simulation-result.component.html',
  styleUrls: ['./simulation-result.component.scss'],
  standalone: false,
})
export class SimulationResultComponent implements OnInit {
  @Output() simulate: EventEmitter<string> = new EventEmitter();
  @Input() simulateResult: SimulateResultData; // SimulateResultModel;
  @Input() isAdvanceSimulator: boolean;

  euribor: string;

  RESULT = {
    SUSSCESS: 0.3,
    DANGER: 0.5,
  };

  lastMoneyContribute = 0;

  constructor(
    private confirmationService: ConfirmationService,
    private _mortgageService: MortgageService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    // this.getAmountNotFinanced();
    this._mortgageService.getEuribor().subscribe(({ euribor }) => {
      this.euribor = euribor;
    });
  }

  simulateAgain() {
    this.simulate.emit();
  }

  getAmountNotFinanced() {
    if (this.simulateResult.mortgageResult) {
      return (
        parseFloat(this.simulateResult.mortgageResult.expenses.trading.total) +
        parseFloat(this.simulateResult.mortgageResult.expenses.mortgage.total) +
        this.simulateResult.formValues.savingsMade
      );
    } else {
      return 0;
    }
  }

  getBonus() {
    let bonus = 0;
    if (this.simulateResult.mortgageResult) {
      for (const item in this.simulateResult.mortgageResult.expenses.mortgage) {
        if (this.simulateResult.mortgageResult.expenses.mortgage[item].bonus) {
          bonus =
            bonus +
            parseFloat(this.simulateResult.mortgageResult.expenses.mortgage[item].bonus);
        }
      }
      for (const item in this.simulateResult.mortgageResult.expenses.trading) {
        if (this.simulateResult.mortgageResult.expenses.trading[item].bonus) {
          bonus =
            bonus +
            parseFloat(this.simulateResult.mortgageResult.expenses.trading[item].bonus);
        }
      }
    }
    return Math.abs(bonus);
  }

  totalNotaryMortgage() {
    return this.simulateResult.mortgageResult
      ? parseFloat(
          this.simulateResult.mortgageResult.expenses.mortgage.notary.intervention,
        ) + parseFloat(this.simulateResult.mortgageResult.expenses.mortgage.notary.duty)
      : '0';
  }

  totalNotaryTrading() {
    return this.simulateResult.mortgageResult
      ? parseFloat(
          this.simulateResult.mortgageResult.expenses.trading.notary.intervention,
        ) + parseFloat(this.simulateResult.mortgageResult.expenses.trading.notary.duty)
      : '0';
  }

  openModal(type: string) {
    let titleModal = '';
    let message = '';
    switch (type) {
      case 'interes': {
        titleModal = this.translate.instant('simulation_result_your_interest');
        message = this.translate.instant(
          Number(this.simulateResult?.mortgageResult?.params?.numMonthsFixed) === 0
            ? 'pre_simulator.your_interest_0_months'
            : 'pre_simulator.your_interest_new',
          {
            months: this.simulateResult?.mortgageResult?.params?.numMonthsFixed
              ? this.simulateResult?.mortgageResult?.params?.numMonthsFixed
              : '-',
            euribor: this.simulateResult?.mortgageResult?.params?.mortgageDiff,
            insurance: this.simulateResult?.mortgageResult?.params?.insuranceHome,
            boeEuribor: this.euribor,
          },
        );
        break;
      }
      case 'dtiDanger': {
        titleModal = this.translate.instant('simulation_result_economic_effort');
        message = 'simulation_result_economic_effort_msg';
        break;
      }
    }

    const data = { message };
    const options: Object = {
      header: titleModal,
      showHeader: true,
      closeOnEscape: true,
      closable: true,
      styleClass: 'modal-class',
      cancelButton: false,
      acceptButton: false,
    };

    this.confirmationService.confirm(<any>{
      component: ModalGenericComponent,
      options: options,
      data: data,
      accept: (data) => {},
      reject: () => {},
    });
  }

  public openToast(id: string) {
    const elementHTML = document.getElementById(id);
    elementHTML.focus();
  }

  public calculateHeight() {
    let totalHeight;

    if (this.simulateResult.mortgageResult) {
      totalHeight =
        this.convertNum(this.simulateResult.formValues.mortgageAmount) +
        this.convertNum(this.simulateResult.formValues.savingsMade) +
        parseFloat(this.simulateResult.mortgageResult.expenses.trading.total) +
        parseFloat(this.simulateResult.mortgageResult.expenses.mortgage.total);
      listHeight.propertyPrice =
        (this.convertNum(this.simulateResult.formValues.mortgageAmount) * 100) /
        totalHeight;
      listHeight.savingsMade =
        (this.convertNum(this.simulateResult.formValues.savingsMade) * 100) / totalHeight;
      listHeight.tradingTotal =
        (parseFloat(this.simulateResult.mortgageResult.expenses.trading.total) * 100) /
        totalHeight;
      listHeight.mortgageTotal =
        (parseFloat(this.simulateResult.mortgageResult.expenses.mortgage.total) * 100) /
        totalHeight;
      listHeight.mortgageAmount =
        (this.simulateResult.formValues.mortgageAmount * 100) /
        (totalHeight -
          this.convertNum(this.simulateResult.formValues.mortgageAmount) +
          this.convertNum(this.simulateResult.formValues.mortgageAmount));

      if (listHeight.propertyPrice < 15) {
        const rest = 15 - listHeight.propertyPrice;
        listHeight.savingsMade = listHeight.savingsMade - rest;
        listHeight.propertyPrice = 15;
        listHeight.mortgageAmount = 15;
      }
      if (listHeight.mortgageTotal < 5) {
        const rest = 5 - listHeight.mortgageTotal;
        if (listHeight.propertyPrice > listHeight.savingsMade) {
          listHeight.propertyPrice = listHeight.propertyPrice - rest;
          listHeight.mortgageAmount = listHeight.mortgageAmount - rest;
        } else {
          listHeight.savingsMade = listHeight.savingsMade - rest;
        }
        listHeight.mortgageTotal = 5;
      }
      if (listHeight.tradingTotal < 10) {
        const restTrading = 10 - listHeight.tradingTotal;
        if (listHeight.propertyPrice > listHeight.savingsMade) {
          listHeight.propertyPrice = listHeight.propertyPrice - restTrading;
          listHeight.mortgageAmount = listHeight.mortgageAmount - restTrading;
        } else {
          listHeight.savingsMade = listHeight.savingsMade - restTrading;
        }
        listHeight.tradingTotal = 10;
      }
    }

    return listHeight;
  }

  convertNum(value: string | number) {
    return typeof value === 'number'
      ? value
      : parseFloat(value.toString().split('.').join(''));
  }

  getMoneyContribute() {
    if (this.simulateResult.mortgageResult) {
      this.lastMoneyContribute =
        this.convertNum(this.simulateResult.formValues.savingsMade) +
        parseFloat(this.simulateResult.mortgageResult.expenses.trading.total) +
        parseFloat(this.simulateResult.mortgageResult.expenses.mortgage.total);
    }
    return this.lastMoneyContribute;
  }
}
